import { Home, Settings } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate, useLocation } from "react-router-dom";
import { HeaderParticleSystem } from "./HeaderParticleSystem";

export const MainHeader = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const isLegalPage = location.pathname === '/privacy-policy' || location.pathname === '/terms-of-service';
  
  return (
    <header className="bg-primary sticky top-0 z-50 h-[80px]">
      <div className="absolute inset-0 pointer-events-none">
        <HeaderParticleSystem />
      </div>
      <div className="relative max-w-[2000px] mx-auto w-full h-full flex items-center justify-between px-8 pointer-events-auto">
        <div className="flex items-center space-x-2">
          <img 
            src="/maia_logo_white.svg" 
            alt="Maia Logo"
            className="h-8 w-auto" 
          />
          {/* Hidden content for SEO - uses sr-only utility from Tailwind */}
          <div className="sr-only">
            <h1>
              Maia - AI-Powered Email Assistant for Gmail | Intelligent Email and Response Generation
            </h1>
            <h2>
              Professional Email Management Solution for Businesses and freelancers.
            </h2>
            <h3>
              Smart Email Response Generation with AI Technology
            </h3>
            <p>
              Streamline your email workflow with Maia's advanced AI assistant. 
              Automatically generate contextually appropriate responses, manage multiple 
              email accounts, and improve communication efficiency.
            </p>
            <h2>
             Answer email in batches saving precious time, with multi-account and multi-assitants
            </h2>
            <p>
              Features include intelligent response generation, multi-account management, 
              customizable AI assistants with document upload, and seamless integration with Gmail.
            </p>
          </div>
        </div>
        <Button 
          variant="secondary" 
          onClick={() => navigate(isLegalPage ? '/' : '/settings')}
          className="relative z-10"
        >
          {isLegalPage ? (
            <>
              <Home className="h-4 w-4 mr-2" />
              Home
            </>
          ) : (
            <>
              <Settings className="h-4 w-4 mr-2" />
              Settings
            </>
          )}
        </Button>
      </div>
    </header>
  );
};
